/*********************************************************************************************
 * Splide Collection - Initialisation
 *
 */
function initializeSplideCollection(splideElem) {
    var splideInstance = new Splide(splideElem, {
        type        : 'slide',
        arrows      : false,
        pagination  : false,
        perPage     : 1,
        snap        : true,
        fixedWidth  : 'fit-content',
        gap         : '8px',
        destroy     : true,
        breakpoints : {
            1024: {
                destroy     : false,
            }
        }
    }).mount();

    // Ajout de l'écouteur d'événement pour le défilement horizontal
    addHorizontalScrollListener(splideElem, splideInstance);
}

/*********************************************************************************************
 * Splide Collection - Initialisation
 *
 */
function initializeSplideCollectionMegaMenuMobile(splideElem) {
    var splideInstance = new Splide(splideElem, {
        type        : 'slide',
        arrows      : false,
        pagination  : false,
        perPage     : 1,
        snap        : true,
        fixedWidth  : 'fit-content',
        gap         : '8px',
        destroy     : true,
        breakpoints : {
            1024: {
                destroy     : false,
            }
        }
    }).mount();

    // Ajout de l'écouteur d'événement pour le défilement horizontal
    addHorizontalScrollListener(splideElem, splideInstance);
}

/*********************************************************************************************
 * Splide Collection Search - Initialisation
 *
 */
function initializeSplideCollectionSearch(splideElem) {
    var splideInstance = new Splide(splideElem, {
        type        : 'slide',
        arrows      : false,
        pagination  : false,
        perPage     : 1,
        snap        : true,
        fixedWidth  : 'fit-content',
        gap         : '8px',
        destroy     : true,
        breakpoints : {
            768: {
                destroy     : false,
            }
        }
    }).mount();

    // Ajout de l'écouteur d'événement pour le défilement horizontal
    addHorizontalScrollListener(splideElem, splideInstance);
}

/*********************************************************************************************
* Loaded Listenner
	*
*/
document.addEventListener("DOMContentLoaded", () => {
	initializeSectionsWithSplide('data-mm-header', '.mm-menu-mobile-collection-splide', initializeSplideCollection);
	document.querySelectorAll('.mm-mega-menu-mobile-collections-splide').forEach(function(elem) {
		if (elem.querySelectorAll('.splide__slide').length > 0) {
			initializeSplideCollectionMegaMenuMobile(elem);
		}
	});
	initializeSectionsWithSplide('data-mm-header', '.mm-predictive-search-products-container-splide', initializeSplideCollectionSearch);
});

window.addEventListener('resize', () => {
    initializeSectionsWithSplide('data-mm-header', '.mm-menu-mobile-collection-splide', initializeSplideCollection);
	document.querySelectorAll('.mm-mega-menu-mobile-collections-splide').forEach(function(elem) {
		if (elem.querySelectorAll('.splide__slide').length > 0) {
			initializeSplideCollectionMegaMenuMobile(elem);
		}
	});
	initializeSectionsWithSplide('data-mm-header', '.mm-predictive-search-products-container-splide', initializeSplideCollectionSearch);
});